export class UploadFileDocumento {
    public File: File;
    public Descricao: string;
    public documentoIdModel: any;
    public subcategoriaModel: any;
    public somenteDesdeProcessoModel: boolean = true;
    public progress: number = 0;
}

export class UploadStatusNome {
  status = false;
  nomeArquivo = '';
}
